import { createFileRoute, redirect } from '@tanstack/react-router';

/// `/` is the resident submission flow. We redirect at route load so
/// there's no flash of a landing page — admins reach `/admin/*` by
/// typing the URL directly, not via a button on the public surface.
export const Route = createFileRoute('/')({
  beforeLoad: () => {
    throw redirect({ to: '/submit' });
  },
});
